import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

export interface AppConfigDto {
  key: string;
  value: string;
  description: string | null;
}

export interface UpdateConfigRequest {
  configs: { key: string; value: string }[];
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private endpoint = environment.apiEndpoint;

  constructor(private http: HttpClient) {}

  getAllConfigs(): Observable<AppConfigDto[]> {
    return this.http.get<AppConfigDto[]>(`${this.endpoint}/v1/configs`);
  }

  updateConfigs(configs: { key: string; value: string }[]): Observable<AppConfigDto[]> {
    return this.http.put<AppConfigDto[]>(`${this.endpoint}/v1/configs`, { configs });
  }
}
